import React, { Component } from 'react';
import Header from './../../Header';
import { Link, Redirect } from "react-router-dom";
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
import { Multiselect } from 'multiselect-react-dropdown';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import HeaderMob from './../../HeaderMob';

class LiveChat extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            total_er: [],
            chat_search: '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            recentlyview: localStorage.getItem('recentlyview') ? localStorage.getItem('recentlyview').split(',') : [],
            activePage: 1,
            item_count: '',
            loading: 1,
            isLoadMore: 1,
            snippet_order_by: 'desc',
            snippet_order_column: 'last_updated_date',
            getFilters: [],
            prodname: [],
            podname: [],
            platname: [],
            featurename: [],
            ProductNameId: [],
            FeatureNameId: [],
            pods: [],
            customerIds: [],
            fromdate: '',
            todate: '',
            from_date: '',
            to_date: '',
        };
        this.searchChange = this.searchChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.multiselectionChange = this.multiselectionChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.multiselectProductName = React.createRef();
        this.multiselectPodName = React.createRef();
        this.multiselectFeatureName = React.createRef();


    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }



    onSelect = (selectedList, selectedItem) => {
        if (this.multiselectProductName.current.state.selectedValues.length >= 3) {
            this.setState({
                productclass: true
            })
        }
        this.state.ProductNameId.push(selectedItem.product_name);

        this.getChatList();
    }

    onRemove = (selectedList, removedItem) => {
        if (this.multiselectProductName.current.state.selectedValues.length < 3) {
            this.setState({
                productclass: false
            })
        }
        if (removedItem == 0) {
            this.setState({ height: null, ProductNameId: [] }, () => this.ListER());
        }
        const index = this.state.ProductNameId.indexOf(removedItem.product_name);
        if (index > - 1) {
            this.state.ProductNameId.splice(index, 1)

            if (this.state.ProductNameId.length > 0) {

                this.getChatList();
                
            } else {
                this.ListER();
                this.setState({ height: null });
            }
        } else {
            this.ListER();
            this.setState({ height: null });
        }
    }
    onSelectPod = (selectedList, selectedItem) => {
        if (this.multiselectPodName.current.state.selectedValues.length >= 3) {
            this.setState({
                podclass: true
            })
        }
        this.state.pods.push(selectedItem.pod_name);
        
        this.getChatList();
    }

    onRemovePod = (selectedList, removedItem) => {
        if (this.multiselectPodName.current.state.selectedValues.length < 3) {
            this.setState({
                podclass: false
            })
        }
        if (removedItem == 0) {
            this.setState({ height: null, pod_name: [] }, () => this.ListER());
        }
        const index = this.state.pods.indexOf(removedItem.pod_name);
        if (index > -1) {
            this.state.pods.splice(index, 1)

            if (this.state.pods.length > 0) {
                this.getChatList();
            } else {
                this.ListER();
                this.setState({ height: null });
            }
        } else {
            this.ListER();
            this.setState({ height: null });
        }
    }
    onSelectFeature = (selectedList, selectedItem) => {
        if (this.multiselectFeatureName.current.state.selectedValues.length >= 3) {
            this.setState({
                featureclass: true
            })
        }
        this.state.FeatureNameId.push(selectedItem.feature);
        this.getChatList();
    }

    onRemoveFeature = (selectedList, removedItem) => {
        if (this.multiselectFeatureName.current.state.selectedValues.length < 3) {
            this.setState({
                featureclass: false
            })
        }
        if (removedItem == 0) {
            this.setState({ height: null, FeatureNameId: [] }, () => this.ListER());
        }
        const index = this.state.FeatureNameId.indexOf(removedItem.feature);
        if (index > - 1) {
            this.state.FeatureNameId.splice(index, 1)

            if (this.state.FeatureNameId.length > 0) {
                this.getChatList();
            } else {
                this.ListER();
                this.setState({ height: null });
            }
        } else {
            this.ListER();
            this.setState({ height: null });
        }
    }
    
    

    multiselectionChange(value, id) {
        this.setState({ [id]: value, activePage: 1 }, function () {
            this.ListER();
        });
    }

    searchChange(event) {
        var obj = this;
        this.setState({ chat_search: event.target.value, activePage: 1 });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.ListER();
        }, 500);
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    Reset() {
        var all_filters = this.getAllfilterKeys();
        for (var key in all_filters) {
            localStorage.setItem(all_filters[key], '');
            this.setState({ [all_filters[key]]: '', activePage: 1 });
        }
        var obj = this;
        setTimeout(function () {
            obj.ListER();
        }, 100);
    }

    handlePageChange(pageNumber = 1) {
        this.setState({ activePage: pageNumber });
        this.getChatList(pageNumber);
    }

    getChatList(page = 1){

        fetch(this.state.apiUrl + '/ErRest/ListLiveChat/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                //findresponse = this.decrypt(findresponse, 1);
                console.log("findrespose", findresponse);

                document.getElementById('loader-new').classList.add("hidden");
                document.getElementById('list_check').classList.remove("hidden");
                this.setState({
                    total_er: findresponse.total_er,
                    config: findresponse.config,
                    owners: findresponse.owners,
                    loading: 0,
                    item_count: findresponse.item_count,
                    isLoadMore: 1,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count
                })
            })

    }

    ListER(page = 1) {
        document.getElementById('loader-new').classList.remove("hidden");
        document.getElementById('list_check').classList.add("hidden");
        this.getChatList();
    }

    jumpSubmit(event) {
        var obj = this;
        if (event.key == 'Enter') {
            if (isNaN(event.target.value)) {
                this.setState({ search: event.target.value, activePage: 1 });
                //Delaying the function execute
                if (this.timer) {
                    window.clearTimeout(this.timer);
                }
                this.timer = window.setTimeout(function () {
                    //Execute the function code here...
                    obj.ListER();
                }, 500);
            } else {
                fetch(this.state.apiUrl + '/ErRest/viewEr/userAuthKey/' + this.state.userAuthKey + "/id/" + event.target.value + "/is_snippet/1")
                    .then((Response) => Response.json())
                    .then((responseJson) => {
                        //responseJson = this.decrypt(responseJson, 1);
                        if (responseJson.er.id) {
                            this.props.history.push('/viewEr/' + responseJson.er.id);
                        } else
                            obj.ListER();
                    })
            }
        }
    }

    onToggle(unique_id) {
        if (document.getElementById('showmore' + unique_id).innerHTML == '<i class="fal fa-angle-down"></i>') {
            document.getElementById('showmore' + unique_id).innerHTML = '<i class="fal fa-angle-up"></i>'
        } else {
            document.getElementById('showmore' + unique_id).innerHTML = '<i class="fal fa-angle-down"></i>'
        }
    }

    onTogglemob(unique_id) {
        if (document.getElementById('showmoremob' + unique_id).innerHTML == '<i class="fal fa-angle-down"></i>') {
            document.getElementById('showmoremob' + unique_id).innerHTML = '<i class="fal fa-angle-up"></i>'
        } else {
            document.getElementById('showmoremob' + unique_id).innerHTML = '<i class="fal fa-angle-down"></i>'
        }
    }

    getUserRows() {
        return (
            <div>
                <div class="loader-new" id="loader-new"></div>
                <div class="list_check hidden" id="list_check">
                    <div class="tickets hidden-sm">
                        <div class="total_feature">Total Record : {this.state.item_count}</div>

                        <ul class="tickets_head">
                            <li class="intra_col_10 padding_left_12" id="col_id"><b>ID</b></li>
                            <li class="intra_col_13" id="col_tags"><b>Summary</b></li>
                            <li class="intra_col_13 padding_left_12" id="col_name"><b>Lead Name</b></li>
                            <li class="intra_col_13" id="col_id"><b>Products</b></li>
                            <li class="intra_col_13" id="col_id"><b>PODs</b></li>
                            <li class="intra_col_13" id="col_id"><b>Features</b></li>
                            <li class="intra_col_6" id="col_chat_agent_steve"><b>Agent</b></li>
                            <li class="intra_col_6" id="col_chat_agent_steve"><b>Lines</b></li>
                            <li class="intra_col_13" id="col_date"><b>Start Time</b></li>
                        </ul>
                        {
                            this.state.total_er.map((value, sequence) =>
                                <ul class="tickets_number">
                                    {
                                        value.value.map((er, val) =>
                                            val == 0 ? <span>
                                                <li class="intra_col_10 padding_left_10 er_color">
                                                    <Link key={val} to={`/EditChat/${er.transcript_id}`} name={"max"} className="">
                                                        {er.transcript_id}
                                                    </Link>
                                                </li>
                                                <li class="intra_col_13 text-inded">{er.title ? er.title : '--NA--'}</li>
                                                <li class="intra_col_13 padding_left_12"><span dangerouslySetInnerHTML={{ __html: er.visitor_name }}></span></li>
                                                <li class="intra_col_13 text-inded" title={er.product}>{er.product ? er.product : '--NA--'}</li>
                                                <li class="intra_col_13 text-inded"title={er.pod}>{er.pod ? er.pod : '--NA--'}</li>
                                                <li class="intra_col_13 text-inded" title={er.feature}>{er.feature ? er.feature : '--NA--'}</li>
                                                <li class="intra_col_6 text-inded">{er.agent_name ? er.agent_name : "--NA--"}</li>
                                                <li class="intra_col_6 text-inded">{er.chat_lines ? er.chat_lines : "--NA--"}</li>
                                                <li class="intra_col_13"><span dangerouslySetInnerHTML={{ __html: er.start_date }}></span></li>
                                                <br></br>
                                            </span> : ''
                                        )
                                    }
                                </ul>
                            )
                        }
                    </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}
                </div>
            </div>
        )
    }
    goToErDetails(id) {
        window.location.href = '/viewEr/' + id;
    }
    componentDidMount() {
        var obj = this;
        document.title = "Intranet | Live Chat";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        //End
        setTimeout(function () {
            obj.ListER();
        }, 100);
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.customer').find('.filter_dept').slideToggle('slow');
        });
        fetch(this.state.apiUrl + '/ErRest/allProductName/userAuthKey/' + this.state.userAuthKey, {
            dataType: 'json'
        }).then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    prodname: findresponse.product_name,
                    podname: findresponse.pod_name,
                    platname: findresponse.app_name,
                    featurename: findresponse.feature,
                })

            })
    }
    handleCallback(start, end, label) {

        console.log("daterange", start, end, label);
    }
    applyHandler = (event, picker) => {
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-DD 00:00:00'),
            to_date: picker.endDate.format('YYYY-MM-DD 23:59:00')
        }, () => {
            this.ListER()
        })
    }
    handleApply = (event, picker) => {
        picker.element.val( picker.startDate.format('DD/MM/YYYY ') + ' - ' + picker.endDate.format('DD/MM/YYYY') );
        this.setState({
            from_date: picker.startDate.format('YYYY-MM-DD 00:00:00'),
            to_date: picker.endDate.format('YYYY-MM-DD 23:59:00')
        }, () => {
            this.ListER()
        })
    };
    handleEvent = (event, picker) => {
        this.setState({
            inputStart: picker.startDate.format('YYYY-MM-DD 00:00:00'),
            inputFinish: picker.endDate.format('YYYY-MM-DD 23:59:00')
        });

    }
    onCancel = (event, picker) => {

        this.setState({

            from_date: '',
            to_date: ''
        }, () => {

            this.ListER();
            picker.element.val(
                'From Date - To Date'
            );


        })
    }
   
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        return (
            <div>
                <Header brecum_name="Live Chat" brecum_page="Live Chat" />
                <div class="right_col">
                    <section class="customer">
                        <div id="exTab1" class="container">
                            <ul class="nav nav-pills pull-left border_less hidden-sm">
                                <li class="">
                                    <div class="title mob"><HeaderMob page_name="Live Chat Transcripts" /></div>

                                </li>
                            </ul>
                            <hr class="live_chat_hr"></hr>
                            <div class=" er_content clearfix">
                                <div class="tab-pane active" id="Leads">
                                    <div class="top-row m_t_20 chatlist_bro">
                                        <div class="right-section er_box">
                                            <div class="form-horizontal er_cal_icon" action="/action_page.php">
                                                <div class="row mar_btm_16">
                                                    <div class="col-md-4 pull-right">
                                                        <div class="searchTicket">
                                                            <input type="text" value={this.state.chat_search} class="form-control" name="chat_search" id="chat_search" placeholder="Search for a ID/ Summary/ Lead/ Agent" onChange={this.searchChange} onKeyPress={this.jumpSubmit.bind(this)} />
                                                            <button type="submit"><i class="fa fa-search"></i></button>
                                                        </div>
                                                        <div class="searchTicket filter dept hidden-md"><i class="fal fa-filter"></i></div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <label class="status_vw" >Features:</label>
                                                        <div className={` filter ${this.state.featureclass ? 'class' : ''}`}>
                                                            <Multiselect
                                                                options={this.state.featurename}
                                                                displayValue="feature"
                                                                // onSelect={this.handleChange}
                                                                onSelect={this.onSelectFeature.bind(this)}
                                                                ref={this.multiselectFeatureName}
                                                                onRemove={this.onRemoveFeature.bind(this)}
                                                                selectedValues={this.state.selectedValue ? this.state.selectedValue : (this.state.getFilters != '' && this.state.getFilters.customer != "") &&
                                                                    this.state.getFilters.customer.map((item) => {
                                                                        return { feature: item.feature }
                                                                    })}
                                                                onKeyPress={this.onRemove.bind(this)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label class="status_vw">Products:</label>
                                                        <div class="filter">
                                                            <div className={`filter ${this.state.productclass ? 'class' : ''}`}>
                                                                <Multiselect
                                                                    options={this.state.prodname}
                                                                    displayValue="product_name"
                                                                    selectedValues={this.state.selectedValue ? this.state.selectedValue : (this.state.getFilters != '' && this.state.getFilters.customer != "") &&
                                                                        this.state.getFilters.customer.map((item) => {
                                                                            return { product_name: item.product_name }
                                                                        })}
                                                                    onSelect={
                                                                        this.onSelect.bind(this)}
                                                                    onRemove={this.onRemove.bind(this)}
                                                                    ref={this.multiselectProductName}
                                                                    onKeyPress={this.onRemove.bind(this)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label class="status_vw">PODs:</label>
                                                        <div class="pod_list_drpdwn">
                                                            <div class="filter">
                                                                <div className={`filter ${this.state.podclass ? 'class' : ''}`}>
                                                                    <Multiselect
                                                                        options={this.state.podname}
                                                                        displayValue="pod_name"
                                                                        // onSelect={this.handleChange}
                                                                        selectedValues={this.state.selectedValue ? this.state.selectedValue : (this.state.getFilters != '' && this.state.getFilters.customer != "") &&
                                                                            this.state.getFilters.customer.map((item) => {
                                                                                return { pod_name: item.pod_name }
                                                                            })}
                                                                        onSelect={
                                                                            this.onSelectPod.bind(this)}
                                                                        onRemove={this.onRemovePod.bind(this)}
                                                                        ref={this.multiselectPodName}
                                                                        onKeyPress={this.onRemove.bind(this)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label class="status_vw">Chat Date:</label>
                                                        <div class= "live-icon-calender">
                                                        <div class="filter">
                                                            <DateRangePicker
                                                                initialSettings={{
                                                                    showDropdowns: true,

                                                                    autoUpdateInput: false,
                                                                    linkedCalendars: false,
                                                                    locale: { cancelLabel: 'Clear', },
                                                                }}
                                                                onCallback={this.handleCallback}
                                                                onApply={this.handleApply}
                                                                onEvent={this.handleEvent}
                                                                onCancel={this.onCancel}
                                                            >
                                                                <input className="form-control" name="date_range" defaultValue="" placeholder="From Date - To Date" />
                                                            </DateRangePicker>
                                                            <i class="fal fa-calendar-alt"></i>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {this.getUserRows()}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}
export default LiveChat;


// WEBPACK FOOTER //
// ./src/components/er/LiveChat.js